module.exports = __webpack_public_path__ + "img/Rectangle 21.74c2aa26.png";